import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Container, Row, Col, Button, Form, FloatingLabel
} from 'react-bootstrap';
import $ from 'jquery';

export default function Policies(props) {
    React.useEffect(function() {
        setTimeout(() => {
            $("[data-target='" + window.location.hash + "']").click();  
        }, 500);

        $(document).on("click", ".list-group-item-action", function() {
            $($(this).data("target")).slideToggle();
            $(this).toggleClass("active");
        });
    }, []);

    return (<>
        <Container fluid id="policy-page" className="py-5">
            <Row className="justify-content-center my-5">
                <Col xs={11} xl={9} xxl={7} className="rounded-3 border shadow-dark bg-white text-black">
                    <div className="row my-5">
                        <div className="col">
                            <h1>Policies</h1>
                        </div>
                    </div>
                    <div className="row justify-content-center mb-5">
                        <div className="col">
                            <ul className="list-group">
                                {/* {{!-- Header --}} */}
                                <li className="list-group-item list-group-item-dark">
                                    <div className="row">
                                        <div className="col-8">
                                            Policy
                                        </div>
                                        <div className="col-4">
                                            Date Updated
                                        </div>
                                    </div>
                                </li>
                                {/* {{!-- TICKET DISCLAIMER --}} */}
                                <li className="list-group-item list-group-item-action" data-target="#policy4">
                                    <div className="row">
                                        <div className="col-8">
                                            Ticket Disclaimer
                                        </div>
                                        <div className="col-4">
                                            October 2021
                                        </div>
                                    </div>
                                </li>
                                <li id="policy4" className="list-group-item collapse">
                                    <div className="row">
                                        <div className="col">
                                            <p>Read this warning before entering any haunted attraction, the Brimstone Haunted Hayride, The Bog, Psychosis, Zombie Assault, Dead Shot Paintball, Cranium Crusher and Axe Throwing. Brimstone Haunt, LLC reserves the right to refuse admission to anyone. You will experience intense audio, lighting, extreme low visibility, strobe lights, fog, damp or wet conditions, moving floors, special effects, sudden actions, and an overall physically demanding environment. DO NOT ENTER the attraction if you are intoxicated, taking medication or using drugs or wearing any form of cast, medical brace, crutches, or have any type of physical limitations. You will not be admitted if these conditions are noticed by our staff. DO NOT ENTER IF YOU SUFFER FROM ASTHMA, HEART CONDITIONS, SEIZURES, MENTAL, PHYSICAL, RESPIRATORY, OR MEDICAL PROBLEMS OR IF YOU ARE PREGNANT OR SUFFER FROM ANY MENTAL DISEASES INCLUDING CLAUSTROPHOBIA. DO NOT smoke, run, eat or drink during the attraction. NO touching actors, customers, or props inside the attraction. NO video or flash photography may be taken during the attraction. Failing to follow these rules will result in being removed from the property immediately. NO REFUNDS. ENTER AT YOUR OWN RISK! Your ticket is a revocable license and may be taken and admission refused upon refund of purchase price. Holder of the ticket understands that there are inherent risks involved with attending these attractions. Holder voluntarily assumes all risks and dangers associated with participation in these attractions. In consideration and acceptance of entrance into either attraction, the holder agrees to release the operator, Brimstone Haunt, LLC, all affiliates, owners, and employees from any liability, harm, injury or death, cost or expenses whatsoever that may arise directly or indirectly from attending these attractions at this location.</p>
                                        </div>
                                    </div>
                                </li>
                                {/* {{!-- PHOTO AND VIDEO --}} */}
                                <li className="list-group-item list-group-item-action" data-target="#policy2">
                                    <div className="row">
                                        <div className="col-8">
                                            Photography and Video
                                        </div>
                                        <div className="col-4">
                                            August 2018
                                        </div>
                                    </div>
                                </li>
                                <li id="policy2" className="list-group-item collapse">
                                    <div className="row">
                                        <div className="col">
                                            <h5>Vistor Camera Use</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>All photography and video is prohibited inside of the attractions. It is allowed in queue lines and the midway/tickets/concessions area.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <h5>Our Camera Use</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>While visiting Brimstone Haunt, you may be photographed or video recorded. These images and video may be used in the future for educational or marketing purposes. Admission to Brimstone Haunt or its programs serves as permission for image and video use.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <h5>Contact Us</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>If you have questions or comments about this Photography and Video Policy, please contact us at: <a href="mailto:contact@brimstonehaunt.com">contact@BrimstoneHaunt.com</a>.</p>
                                        </div>
                                    </div>
                                </li>
                                {/* {{!-- COOKIES --}} */}
                                <li className="list-group-item list-group-item-action" data-target="#policy3">
                                    <div className="row">
                                        <div className="col-8">
                                            Web Cookies
                                        </div>
                                        <div className="col-4">
                                            September 2020
                                        </div>
                                    </div>
                                </li>
                                <li id="policy3" className="list-group-item collapse">
                                    <div className="row">
                                        <div className="col">
                                            <h5>Introduction</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>Brimstone Haunt may use cookies, and other tracking technologies when you visit our website [brimstonehaunt.com.com], including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the “Site”) to help customize the Site and improve your experience.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>We reserve the right to make changes to this Cookie Policy at any time and for any reason. We will alert you about any changes by updating the “Last Updated” date of this Cookie Policy. Any changes or modifications will be effective immediately upon posting the updated Cookie Policy on the Site, and you waive the right to receive specific notice of each such change or modification.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>You are encouraged to periodically review this Cookie Policy to stay informed of updates. You will be deemed to have been made aware of, will be subject to, and will be deemed to have accepted the changes in any revised Cookie Policy by your continued use of the Site after the date such revised Cookie Policy is posted.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <h5>Use of Cookies</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>A “cookie” is a string of information which assigns you a unique identifier that we store on your computer. Your browser then provides that unique identifier to use each time you submit a query to the Site. We use cookies on the Site to, among other things, keep track of services you have used, record registration information, record your user preferences, keep you logged into the Site, facilitate purchase procedures, and track the pages you visit. Cookies help us understand how the Site is being used and improve your user experience.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <h5>Contact Us</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>If you have questions or comments about this Cookie Policy, please contact us at: <a href="mailto:contact@brimstonehaunt.com">contact@BrimstoneHaunt.com</a>.</p>
                                        </div>
                                    </div>
                                </li>
                                {/* {{!-- Privacy --}} */}
                                <li className="list-group-item list-group-item-action" data-target="#policy5">
                                    <div className="row">
                                        <div className="col-8">
                                            Privacy Policy
                                        </div>
                                        <div className="col-4">
                                            August 2024
                                        </div>
                                    </div>
                                </li>
                                <li id="policy5" className="list-group-item collapse">
                                    <div className="row">
                                        <div className="col">
                                            <p>This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Definitions</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p><strong>Account:</strong> A unique account created for You to access our Service or parts of our Service.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p><strong>Company:</strong> Brimstone Haunt, LLC, 525 Brimstone Road Wilmington OH 45177.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p><strong>Cookies:</strong> Small files placed on Your computer, mobile device, or any other device by a website, containing the details of Your browsing history on that website.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p><strong>Device:</strong> Any device that can access the Service such as a computer, cellphone, or tablet.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p><strong>Personal Data:</strong> Any information that relates to an identified or identifiable individual.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Collecting and Using Your Personal Data</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>We collect various types of information for different purposes to provide and improve our Service.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p><strong>Personal Data:</strong> While using Our Service, We may ask You to provide Us with personally identifiable information, such as email address, name, phone number, and address.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p><strong>Usage Data:</strong> Usage Data is collected automatically and may include information such as Your device's IP address, browser type, and the time spent on certain pages of our Service.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p><strong>Tracking Technologies and Cookies:</strong> We use Cookies and similar tracking technologies to track activity on Our Service and store certain information. You can instruct Your browser to refuse all cookies or to indicate when a cookie is being sent.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Use of Your Personal Data</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>The Company uses Your Personal Data to provide and maintain Our Service, manage Your account, and perform contracts such as the purchase of products or services. We may also use the data to contact You, provide news, manage requests, and for other purposes like data analysis and improving the Service.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <h5>Sharing Your Personal Data</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>We may share Your personal information with Service Providers, business partners, affiliates, or in connection with business transfers such as mergers or sales of the Company. We may also share Your data with other users, with Your consent, or as required by law.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Security of Your Personal Data</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>We take reasonable precautions to protect Your data, but no transmission method over the Internet or electronic storage is completely secure.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Children’s Privacy</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children without parental consent.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Changes to This Privacy Policy</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>We may update this Privacy Policy from time to time. You are advised to review this page periodically for any changes.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Contact Us</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:contact@brimstonehaunt.com">contact@brimstonehaunt.com</a>.</p>
                                        </div>
                                    </div>
                                </li>
                                {/* {{!-- COOKIES --}} */}
                                <li className="list-group-item list-group-item-action" data-target="#policy6">
                                    <div className="row">
                                        <div className="col-8">
                                            Terms of Use
                                        </div>
                                        <div className="col-4">
                                            August 2024
                                        </div>
                                    </div>
                                </li>
                                <li id="policy6" className="list-group-item collapse">
                                    <div className="row">
                                        <div className="col">
                                            <p>We are Brimstone Haunt, LLC ("Company", "we", "us", or "our"), a company registered in Ohio, United States, at 317 Brimstone Road, Wilmington, OH 45177. We operate the website brimstonehaunt.com ("Site"), as well as any other related products and services that refer or link to these legal terms (the "Legal Terms") (collectively, the "Services").</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Agreement to Our Legal Terms</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>These Legal Terms constitute a legally binding agreement between you ("you") and Brimstone Haunt, LLC, regarding your access to and use of the Services. By using the Services, you agree to be bound by all of these Legal Terms.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>User Representations</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>By using the Services, you represent and warrant that all registration information you submit will be accurate and that you agree to comply with these Legal Terms.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Intellectual Property Rights</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>We are the owner or licensee of all intellectual property rights in our Services, including all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics in the Services. Our content and marks are protected by copyright and trademark laws.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Use of Our Services</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>We grant you a non-exclusive, non-transferable, revocable license to access and use the Services solely for your personal, non-commercial use.</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5>Contact Us</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>If you have questions or comments, please contact us at: <a href="mailto:contact@brimstonehaunt.com">contact@brimstonehaunt.com</a></p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </>)
}